import { Link } from "gatsby";
import React, { useState, FC } from "react";
import { useFormik } from "formik";
import * as Yup from "yup";

const validationSchema = Yup.object({
  name: Yup.string().required("El nombre es obligatorio"),
  lastname: Yup.string().required("El apellido es obligatorio"),
  phone: Yup.string().required("El celular es obligatorio"),
  email: Yup.string().email("Correo inválido").required("El correo es obligatorio"),
  verification: Yup.boolean().oneOf([true], "Debes aceptar las políticas de privacidad")
});

export const FooterForm: FC = () => {
  const [completed, setCompleted] = useState<boolean>(false);
  const [loading, setLoading] = useState<boolean>(false);
  const [under18, setUnder18] = useState<boolean>(false);
  
  const formik = useFormik({
    initialValues: {
      email: "",
      name: "",
      phone: "",
      lastname: "",
      accepts_advertising: false,
      more18: true,
      parent_name: "",
      parent_phone: "",
      parent_dni: "",
      parent_address: "",
      parent_accepts_advertising: false,
      parent_title: "",
      utm_medium: "form",
      utm_campaign: "subscription_form",
      utm_source: "website",
      form: "subscription",
      verification: false,
    },
    validationSchema,
    onSubmit: (values, { setSubmitting }) => {
      fetch(`${process.env.GATSBY_WORDPRESS_URL}/wp-json/whiz-api/v1/lead`, {
        method: "POST",
        headers: { "Content-Type": "application/json" },
        body: JSON.stringify(values),
        redirect: "follow",
      })
        .then((response) => response.text())
        .then((result) => console.log(result))
        .catch((error) => console.log("error", error))
        .finally(() => {
          setCompleted(true);
          setSubmitting(false);
        });
    },
  });

  // Reset parent fields if the user is older than 18
  const resetParentFields = () => {
    formik.setFieldValue("parent_name", "");
    formik.setFieldValue("parent_title", "");
    formik.setFieldValue("parent_dni", "");
    formik.setFieldValue("parent_phone", "");
    formik.setFieldValue("parent_address", "");
    formik.setFieldValue("parent_accepts_advertising", false);
  };

  return (
    <>
      {completed ? (
        <div className="links-section-bigger">
          <p>¡Hola! Gracias por suscribirte.</p>
          <span>
            De ahora en adelante recibirás la información, noticias y novedades
            de la marca.
          </span>
        </div>
      ) : (
        <div className="links-section-bigger">
          <p className="title gt-dark">
            Suscríbete para recibir novedades y promociones
          </p>
          <form onSubmit={formik.handleSubmit} className="formulario">
            <div className="form-group">
              <label>
                <input
                  type="text"
                  name="name"
                  placeholder="Nombre"
                  className={`form-control ${formik.touched.name && formik.errors.name ? "error" : ""}`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.name}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="text"
                  name="lastname"
                  placeholder="Apellido"
                  className={`form-control ${formik.touched.lastname && formik.errors.lastname ? "error" : ""}`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.lastname}
                />
              </label>
            </div>
            <div className="form-group">
              <label>
                <input
                  type="tel"
                  name="phone"
                  placeholder="Celular"
                  className={`form-control ${formik.touched.phone && formik.errors.phone ? "error" : ""}`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.phone}
                />
              </label>
            </div>
            <div className="form-group bigger">
              <label>
                <input
                  type="email"
                  name="email"
                  placeholder="Correo"
                  className={`form-control ${formik.touched.email && formik.errors.email ? "error" : ""}`}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  value={formik.values.email}
                />
              </label>
            </div>
            <div className="form-group bigger form-validation more18-checkbox">
              <label className="form-label custom-checkbox">
                <input
                  type="checkbox"
                  name="more18"
                  className="form-control"
                  onChange={(e) => {
                    const checked = e.target.checked;
                    formik.setFieldValue("more18", !checked);
                    resetParentFields();
                    setUnder18(checked);
                  }}
                  onBlur={formik.handleBlur}
                  checked={under18}
                />
                <span className="checkmark"></span>
                <span>
                  Declaro que soy menor de 14 años. En caso no lo sea marcar la casilla.
                </span>
              </label>
            </div>
            {under18 && 
              <div className="form-group bigger form-validation more18-instructions">
                <ul className="form-instructions">
                  <li>* Para continuar necesitamos el consentimiento de tu madre / padre 
                    o tu representante legal. <br/> Si deseas seguir pídele que 
                    complete este formulario contigo.
                  </li>
                </ul>
              </div>
            }
            <div className="form-group bigger form-validation">
              <label className={`form-label custom-checkbox flex ${formik.touched.verification && formik.errors.verification ? "error" : ""}`}>
                <input
                  type="checkbox"
                  name="verification"
                  className={"form-control"}
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.verification}
                />
                <span className="checkmark"></span>
                <span>
                  He leído y acepto las{" "}
                  <Link
                    title="políticas de privacidad"
                    to="/politica-de-privacidad"
                    className="non-styled"
                  >
                    políticas de privacidad
                  </Link>{" "}
                  de datos de esta web.
                </span>
              </label>
            </div>
            <div className="form-group bigger form-validation aceptance-checkbox">
              <label className="form-label custom-checkbox">
                <input
                  type="checkbox"
                  name="accepts_advertising"
                  className="form-control"
                  onChange={formik.handleChange}
                  onBlur={formik.handleBlur}
                  checked={formik.values.accepts_advertising}
                />
                <span className="checkmark"></span>
                <span>
                  Acepto el tratamiento de mis datos para fines publicitarios (Opcional)
                </span>
              </label>
            </div>
            {under18 && 
              <>
                <div className="form-group bigger form-validation more18-parent-title">
                  <p className="title gt-dark">
                    Datos del tutor/representante legal:
                  </p>
                </div>
                <div className="form-group more18-field">
                  <label className="form-label">                    
                    <input
                      required
                      type="text"
                      name="parent_name"
                      placeholder="Nombres y Apellidos"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.parent_name}
                    />
                  </label>
                </div>
                <div className="form-group more18-field">
                  <label className="form-label">                    
                    <input
                      required
                      type="text"
                      name="parent_title"
                      placeholder="Parentesco"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.parent_title}
                    />
                  </label>
                </div>
                <div className="form-group more18-field">
                  <label className="form-label">                    
                    <input
                      required
                      type="text"
                      name="parent_dni"
                      placeholder="Número de DNI"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.parent_dni}
                    />
                  </label>
                </div>
                <div className="form-group more18-field">
                  <label className="form-label">                    
                    <input
                      required
                      type="tel"
                      name="parent_phone"
                      placeholder="Teléfono"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.parent_phone}
                    />
                  </label>
                </div>
                <div className="form-group bigger more18-field">
                  <label className="form-label">                    
                    <input
                      required
                      type="text"
                      name="parent_address"
                      placeholder="Dirección/Domicilio"
                      className="form-control"
                      autoComplete="address-line1"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      value={formik.values.parent_address}
                    />
                  </label>
                </div>
                <div className="form-group bigger form-validation more18-aceptance-checkbox">
                  <label className="form-label custom-checkbox">
                    <input
                      type="checkbox"
                      name="parent_accepts_advertising"
                      className="form-control"
                      onChange={formik.handleChange}
                      onBlur={formik.handleBlur}
                      checked={formik.values.parent_accepts_advertising}
                    />
                    <span className="checkmark"></span>
                    <span>
                      Doy consentimiento para el uso de los datos personales del menor con fines promocionales. 
                    </span>
                  </label>
                </div>
              </>
            }
            <button
              type="submit"
              className="button button-suscriber style-primary-footer"
              disabled={formik.isSubmitting}
            >
              <span>Suscríbete</span>
            </button>
          </form>
        </div>
      )}
    </>
  );
};
